import { performSilentOidcAuthWithFallbackToRedirect } from '@diligentcorp/library-oidc-client-frontend-helpers';

import { HttpErrorResponse } from '../../../types/NetworkRequest';
import { handleResponse } from '../../../helpers/responseHandling';
import AppConfig from '../../../AppConfig';
import { Session } from '../../../types/Session';
import http from '../../http';

export default async function getSession(): Promise<Session> {
  try {
    return await handleResponse(
      () => http.get(AppConfig.sessionEndpoint),
      (data) => data as Session,
    );
  } catch (err) {
    // response with 400 with a specific body content when no access token provided
    if (err instanceof HttpErrorResponse && err.response.status === 400) {
      const body: unknown = await err.response.clone().json();

      if (
        typeof body === 'object' &&
        body !== null &&
        'error' in body &&
        body.error === 'invalid_request' &&
        'error_description' in body &&
        body.error_description === 'no access token provided'
      ) {
        await performSilentOidcAuthWithFallbackToRedirect(
          new URL(AppConfig.oidcAuthStartEndpointPath, window.location.origin),
          {
            postAuthRedirectPath: window.location.href.substring(window.location.origin.length),
            lockingStrategy: 'origin',
          },
        );
        return await handleResponse(await http.get(AppConfig.sessionEndpoint), (data) => data as Session);
      }
    }

    // response with 401 or 403 when access token is invalid/expired or wrong audience
    if (err instanceof HttpErrorResponse && (err.response.status === 401 || err.response.status === 403)) {
      await performSilentOidcAuthWithFallbackToRedirect(
        new URL(AppConfig.oidcAuthStartEndpointPath, window.location.origin),
        {
          postAuthRedirectPath: window.location.href.substring(window.location.origin.length),
          lockingStrategy: 'origin',
        },
      );
      return await handleResponse(await http.get(AppConfig.sessionEndpoint), (data) => data as Session);
    }

    throw err;
  }
}
